



































import Vue from 'vue';
import Checkbox from '@/components/FormInputs/Checkbox.vue'
export default Vue.extend({
  name: 'AdminExport',
  data() {
    return {
      deleted: true,
      delimiter: false
    }
  },
  components: {
    Checkbox
  },
  created() {
    this.$store.dispatch('loadExport');
  },
  computed: {
    unternehmen: function() {
      if(this.deleted){
        return this.$store.state.exportdata;
      } else {
        return this.$store.state.exportdata.filter((item) => item.deleted == 0);
      }

    },
    loading: function(){
      return this.$store.state.exportdata.length == 0;
    },
    getdelimiter: function(){
      if(this.delimiter) {
        return ",";
      } else {
        return ";";
      }
    }

  }
});
